import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const GibraltarFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_14889'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_14889)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V9.33337H0V14Z'
					fill='#E34F4F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.66602 9.33331H12.3803V5.59998H6.66602V9.33331Z'
					fill='#E34F4F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M7.61914 9.33336H8.57152V8.40002H7.61914V9.33336Z'
					fill='#181A1A'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.4766 9.33336H11.4289V8.40002H10.4766V9.33336Z'
					fill='#181A1A'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.66602 5.59996H7.6184V4.66663H6.66602V5.59996Z'
					fill='#181A1A'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.52344 5.59996H10.4758V4.66663H9.52344V5.59996Z'
					fill='#181A1A'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.57227 5.59996H9.52465V4.66663H8.57227V5.59996Z'
					fill='#181A1A'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M11.4277 5.59996H12.3801V4.66663H11.4277V5.59996Z'
					fill='#181A1A'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.66602 4.66661H7.6184V3.73328H6.66602V4.66661Z'
					fill='#E34F4F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.52344 4.66661H10.4758V3.73328H9.52344V4.66661Z'
					fill='#E34F4F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.57227 4.66661H9.52465V3.73328H8.57227V4.66661Z'
					fill='#E34F4F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M11.4277 4.66661H12.3801V3.73328H11.4277V4.66661Z'
					fill='#E34F4F'
				/>
			</g>
		</svg>
	);
};

export default GibraltarFlagIcon;
